import { MB, PC } from "./viewport_width";
import { isMobile } from "react-device-detect";
export default function Img(props) {
  return (
    <img
      {...props}
      style={{
        height: `${(props.height / (isMobile ? MB : PC)) * 100}vw`,
        width: `${(props.width / (isMobile ? MB : PC)) * 100}vw`,
      }}
      src={props.src}
      alt={props.alt}
    ></img>
  );
}
